import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {ProjectAgentContainerModel} from "../../../../../../../models/aggregates/alg/cc/project/project-agent-container.model";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class ProjectAgentService extends BaseApiTemplateService<ProjectAgentContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'project-agent-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'project-agent-links';
    this.httpClient = http;
  }
}
